import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';

var _excluded = ["title"];
var IconProfile = function IconProfile(_ref) {
  var title = _ref.title,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "hci-svg-profile"
  }, rest), title && /*#__PURE__*/React__default__default.createElement("title", null, title), /*#__PURE__*/React__default__default.createElement("path", {
    d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a7.96 7.96 0 01-4.5-1.39 2.98 2.98 0 011.82-2.68 6.31 6.31 0 005.36 0 2.98 2.98 0 011.82 2.68A7.96 7.96 0 0112 20zm6.21-2.97a4.94 4.94 0 00-3.8-3.24c-.7.47-1.52.74-2.4.74-.9 0-1.72-.27-2.43-.74a4.94 4.94 0 00-3.8 3.24A8 8 0 1120 12c.01 1.9-.66 3.65-1.77 5.03zM12 6c-1.68 0-3.05 1.55-3.05 3.45 0 1.9 1.37 3.46 3.05 3.46 1.68 0 3.05-1.55 3.05-3.46C15.05 7.55 13.68 6 12 6zm0 4.9c-.56 0-1.05-.67-1.05-1.45 0-.77.5-1.45 1.05-1.45.56 0 1.05.68 1.05 1.45 0 .78-.5 1.46-1.05 1.46z"
  }));
};
IconProfile.displayName = 'InlineIcon(IconProfile)';
IconProfile.defaultProps = {
  title: null
};
IconProfile.propTypes = {
  title: PropTypes__default.string
};

export { IconProfile };
